import { Slider, Stack, Typography, useTheme } from '@mui/material';
import InputWrapper from '../InputWrapper';

interface Props {
  id: string;
  label?: string;
  disabled?: boolean;
  tooltip?: string;
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (value: number) => void;
  isError?: boolean;
  isLabelMultiline?: boolean;
  required?: boolean;
  valueFormatter?: (value: number) => string;
}

function SliderInputControlled({
  id,
  label,
  disabled,
  value,
  onChange,
  tooltip,
  min,
  max,
  step,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isError: _isError,
  isLabelMultiline,
  required,
  valueFormatter = val => String(val),
}: Props) {
  const theme = useTheme();
  return (
    <InputWrapper
      label={label || ''}
      name={id.toString()}
      tooltip={tooltip}
      isLabelMultiline={isLabelMultiline}
      required={required}>
      <Slider
        value={value}
        onChange={(_, newValue) => onChange(newValue as number)}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        valueLabelDisplay="on"
        valueLabelFormat={valueFormatter}
        sx={{
          py: 1,
          color: 'text.primary',
          '& .MuiSlider-valueLabel': {
            fontSize: theme.typography.body2.fontSize,
            fontWeight: 700,
            top: 45,
            backgroundColor: 'unset',
            color: theme.palette.text.primary,
            '&::before': {
              display: 'none',
            },
            '& *': {
              background: 'transparent',
              color: 'text.primary',
              ...theme.applyStyles('dark', {
                color: 'common.white',
              }),
            },
            '& .MuiSlider-valueLabelLabel': {
              background: theme.palette.background.paper,
            },
          },
          '& .MuiSlider-thumb': {
            '&::before': {
              boxShadow: 'none',
            },
            '&:hover, &.Mui-focusVisible, &.Mui-active': {
              boxShadow: 'none',
            },
          },
        }}
      />
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="body2">{valueFormatter(min)}</Typography>
        <Typography variant="body2">{valueFormatter(max)}</Typography>
      </Stack>
    </InputWrapper>
  );
}

export default SliderInputControlled;
